<ion-header no-border mode="md">
	<ion-toolbar color="primary" mode="md">
		<ion-title *ngIf="isAdmin">
			{{ 'externalEvaluation.modalTitle' | translate }}
		</ion-title>
		<ion-title *ngIf="!isAdmin">
			{{ 'externalEvaluation.requestEval' | translate }}
		</ion-title>
		<ion-buttons slot="end">
			<ion-button
				mode="ios"
				size="small"
				color="light"
				(click)="dismiss(false)"
			>
				<ion-icon class="bp-close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<ion-list
		mode="ios"
		lines="full"
		[formGroup]="formGroup"
		class="section-performance"
	>
		<ion-item>
			<ion-label position="stacked" color="primary">
				{{ 'externalEvaluation.nameExternalEvaluator' | translate }}
			</ion-label>
			<ion-input formControlName="name" [maxlength]="150"></ion-input>
		</ion-item>
		<ion-item>
			<ion-label position="stacked" color="primary">
				{{ 'manageUser.email' | translate }}
			</ion-label>
			<ion-input formControlName="email" [maxlength]="150"></ion-input>
		</ion-item>
		<ion-item>
			<ion-label position="stacked" color="primary">
				{{ 'filters.Company' | translate }}
			</ion-label>
			<ion-input formControlName="company" [maxlength]="150"></ion-input>
		</ion-item>
		<ion-item>
			<ion-label position="stacked" color="primary">
				{{ 'generic.role' | translate }}
			</ion-label>
			<ion-input formControlName="role" [maxlength]="150"></ion-input>
		</ion-item>

		<ion-item [disabled]="!isAdmin">
			<ion-label position="stacked">
				{{ 'generic.type' | translate }}
			</ion-label>
			<ion-select
				[placeholder]="'dashboard.selectOne' | translate"
				formControlName="type"
			>
				<ion-select-option *ngFor="let type of types" [value]="type">
					{{ getTypeText(type) | translate}}
				</ion-select-option>
			</ion-select>
		</ion-item>

		<ion-item [disabled]="!isAdmin" *ngIf="cycles.length > 0">
			<ion-label position="stacked">
				{{ 'dashboard.cycle' | translate }}
			</ion-label>
			<ion-select
				[placeholder]="'dashboard.selectOne' | translate"
				formControlName="cycleId"
			>
				<ion-select-option *ngFor="let cycle of cycles" [value]="cycle.cycleId">
					{{ cycle.name }}
				</ion-select-option>
			</ion-select>
		</ion-item>

		<ion-item [disabled]="!isAdmin" class="mark" lines="none">
			<ion-label position="stacked" color="primary">{{ 'externalEvaluation.evaluatee' | translate }}</ion-label>
			<ion-searchbar mode="ios" #usersSearch
			  class="section-search-custom"
			  [placeholder]="'generic.searchByName' | translate"
			  (keyup)="onChangeSearch($event.target.value)">
			</ion-searchbar>
			<ion-list class="users" >
			  <div *ngFor="let user of users;">
				  <p class="user" (click)="setEvaluatedUser(user)" >
					  {{ user.name }}
				  </p>
			  </div>
			  <ion-item class="filters" *ngIf="evaluatedUser">
				  <span class="filter-item">
					  {{ evaluatedUser.name }}
					  <ion-icon (click)="removeEvaluatedUser()" class="bp-close filter-remove"></ion-icon>
				  </span>
			  </ion-item>
			</ion-list>
		</ion-item>
	</ion-list>
</ion-content>

<ion-footer mode="ios">
	<ion-toolbar mode="ios">
		<ion-row>
			<ion-col size="6">
				<ion-button
					color="danger"
					expand="block"
					mode="ios"
					(click)="dismiss(false)"
				>
					{{ 'generic.cancel' | translate }}
				</ion-button>
			</ion-col>
			<ion-col size="6">
				<ion-button
					color="primary"
					expand="block"
					mode="ios"
					(click)="save()"
				>
					{{ 'generic.save' | translate }}
				</ion-button>
			</ion-col>
		</ion-row>
	</ion-toolbar>
</ion-footer>
